
$(document).ready(function() {

    // fancybox globals settings
    //
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.infobar = true;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.smallBtn = true;

    // ---

    // maps link event
    //
    $('.section.maps').on('click', function() {
        window.open(
            'https://goo.gl/maps/8xJ5FTQGyN32',
            '_blank'
        );
        return false;
    });

    // ---

    if($(window).width() < 640) {
        $("#btn").click(function() {
            $(this).toggleClass("active");
            $("ul.nav").toggleClass("show");
            $(".section").toggleClass("hide-section");
            $(".section.showcase").toggleClass("offeset");
        });
        $("#main-nav ul a").click(function() {
            $("#btn").toggleClass("active");
            $("ul.nav").toggleClass("show");
            $(".section").toggleClass("hide-section");
            $(".section.showcase").toggleClass("offeset");
        });
    }

    if($(".section").length > 0) {
        $(".section").waypoint({
            handler: function(event, direction) {

                var activeSection;
                activeSection = $(this);

                if (direction === "up") activeSection = activeSection.prev();
                $('#main-nav li').removeClass("active").find('a[data-target="' + activeSection.attr("id") + '"]').closest('li').addClass("active");
            }
        });
    }

    // initialize mobile nav
    $('#device').css('height', '10px');

    $(".nav").on("click", "a", function() {
        var target = $(this).attr('href');
        //console.log(target);
        $('.nav li').removeClass('active');
        $(this).parent().addClass('active');
        if($(window).width() > 640) {
            $('html, body').animate({ scrollTop: Math.round($(target).offset().top)-80}, 800,function(){$('#device').css('height', '0px')});
        } else {
            $('html, body').animate({ scrollTop: Math.round($(target).offset().top)-190}, 800,function(){$('#device').css('height', '0px')});
        }

        return false;
    });

    $('a#showcase-button').click(function(){
        var target = $(this).attr('href');
        $('html, body').animate({ scrollTop: Math.round($(target).offset().top)-20}, 800,function(){$('#device').css('height', '0px')});
    });

    mobileNav();

    $("#main-nav select").change(function() {
        var target = $(this).attr('value');
        $('html, body').animate({ scrollTop: Math.round($(target).offset().top)-20}, 800,function(){$('#device').css('height', '0px')});
        return false;
    });

    //initialize flexslider
    if($('.flexslider').length > 0) {
        $('.flexslider').flexslider({
            animation: "slide"
        });
    }
});

/*
 * MOBILE NAVIGATION
*********************************************************************************/
function mobileNav() {
    $("<select />").appendTo("#main-nav");

    $("<option />", {
        "selected": "selected",
        "value"   : "",
        "text"    : "Go to..."
    }).appendTo("#main-nav select");

    // Populate dropdown with menu items
    $("#main-nav a").each(function() {
        var el = $(this);
        $("<option />", {
            "value"   : el.attr("href"),
            "text"    : el.text()
        }).appendTo("#main-nav select");
    });
}